import React, { useState, useEffect } from 'react';
import "./style.css";
import { CoursesFeature } from "../CoursesFeature";
import { UnderlinedTitle } from "../UnderlinedTitle";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

// import required modules
import { Pagination, Navigation } from 'swiper/modules';

export const CourseFeaturesList = ({ language, packshot_image }) => {

  const [forceUpdateFlag, setForceUpdateFlag] = useState(false);

  const translations = {
    "en": {
      "video_lessons": "Easy-to-watch Video Lessons",
      "course_features_description": "<p><strong>10 Masters</strong> is an Online Learning Platform that allows you to watch or listen to video lessons from the world's best tattoo artists.</p><p>With 10 Masters, you can learn something anytime, anywhere, at your own pace. It is available on your <strong>smartphone, iPad, or personal computer</strong>.</p><p>Access is easy: once you have enrolled in a course, visit your 10 Masters profile, and there it will be waiting for you, <strong>ready to be completed</strong>.</p>",
      "unlimited_access_text": 'This course doesn’t expire. Learn without time limits, at your own pace.',
      "unlimited_access": "UNLIMITED<br />ACCESS",
      "app_ios_android": "100%<br />ENGLISH AUDIO",
      "app_ios_android_icon": "https://w.10masters.com/media/images/iconmicro.original.png",
      "hd_zoom_videos": "FULL HD VIDEOS & SUPER ZOOM",
      "guarantee": "MONEY-BACK GUARANTEE",
      "contact": 'If you have any questions about the course, you can contact us by e-mail and we\'ll get back to you right away.',
      "app_text": "Access your course in a second from any mobile device thanks to our App.",
      "zoom_text": "So you can see the tattoo in detail as if it was right in front of your eyes (or closer).",
      "try_text": "You can try 30% of the course. If it doesn't fit your needs,  we'll refund your money. No questions asked.",
    },
    "es": {
      "video_lessons": "Lecciones en vídeo fáciles de ver",
      "course_features_description": "<p><strong>10 Masters</strong> es una plataforma online de aprendizaje que te permite ver y escuchar lecciones en video, realizadas por los mejores artistas del tatuaje.</p><p>Con 10 Masters puedes aprender cualquier tema, en cualquier lugar, a tu propio ritmo. Podrás acceder desde tu dispositivo móvil a través de nuestra App, en tu tablet o ordenador.</p><p>El acceso es muy simple: cuando te inscribes en un curso, visita tu perfil privado en 10 Masters y el curso estará ahí esperando, <strong>listo para ser completado</strong>.</p>",
      "unlimited_access_text": 'Podrás completar el curso a tu ritmo, sin límite de tiempo ni caducidad.',
      "unlimited_access": "ACCESO<br />ILIMITADO",
      "app_ios_android": "APP IOS<br />Y ANDROID",
      "app_ios_android_icon": "https://m.10masters.com/images/iphoneicon.original.png",
      "hd_zoom_videos": "VÍDEOS FULL HD Y CON SÚPER ZOOM",
      "guarantee": "GARANTÍA DE DEVOLUCIÓN",
      "contact": 'Si tienes cualquier duda relacionada con el curso, puedes escribirnos por e-mail. Te responderemos al momento.',
      "app_text": "Accede a tu curso en un segundo desde cualquier móvil gracias a nuestra App.",
      "zoom_text": "Para poder ver el tatuaje con todo detalle, como si lo tuvieras delante.",
      "try_text": "Puedes probar el 30% del curso. Si no encaja con lo que buscas, te devolveremos el dinero.",
    },
    "pt": {
      "video_lessons": "Vídeo aulas fáceis de assistir",
      "course_features_description": "<p><strong>10 Masters</strong> é uma plataforma de aprendizagem online que lhe permite ver e ouvir lições em vídeo de tatuadores de topo.</p><p>Com 10 Masters pode aprender qualquer disciplina, em qualquer lugar, ao seu próprio ritmo. Pode aceder-lhe a partir do seu <strong>dispositivo móvel, iPad ou computador pessoal</strong>.</p><p>O acesso é muito simples: ao inscrever-se para um curso, visite o seu perfil privado em 10 Masters e <strong>o curso estará lá à sua espera, pronto para ser concluído<strong>.</p>",
      "unlimited_access_text": 'Este curso não expira. Aprenda sem limites de tempo, ao seu próprio ritmo. ',
      "unlimited_access": "ACCESSO<br />ILIMITADO",
      "app_ios_android": "APP IOS<br />Y ANDROID",
      "app_ios_android_icon": "https://m.10masters.com/images/iphoneicon.original.png",
      "hd_zoom_videos": "FULL HD VIDEOS E CON SUPER ZOOM",
      "guarantee": "GARANTIA DE DEVOLUÇÃO",
      "contact": 'Se você tiver alguma dúvida relacionada ao curso, pode nos escrever por e-mail e responderemos instantaneamente.',
      "app_text": "Acesse seu curso em um segundo de qualquer celular com nosso App.",
      "zoom_text": "Assim você pode ver a tatuagem em detalhes, como se estivesse bem na frente de seus olhos (ou mais perto) ",
      "try_text": "Você pode testar 30% do curso. Se não for o que procura, devolvemos o dinheiro.",
    },
    "fr": {
      "video_lessons": "Des leçons vidéo faciles à regarder",
      "course_features_description": "<p><strong>10 Masters</strong> est une plateforme d'apprentissage en ligne qui vous permet de regarder et d'écouter des leçons vidéo, réalisées par les meilleurs tatoueurs.</p><p>Avec 10 Masters, vous pouvez apprendre n'importe quelle matière, n'importe où, à votre rythme. Vous pouvez y accéder depuis votre <strong>appareil mobile, iPad ou ordinateur personnel</strong>.</p><p>L'accès est très simple : lorsque vous vous inscrivez à un cours, visitez votre profil privé dans 10 Masters et le cours sera là en attente, <strong>prêt à être complété</strong>.</p>",
      "unlimited_access_text": 'Votre cours n\'expirera jamais. Apprenez sans limite de temps, à votre rythme.',
      "unlimited_access": "ACCÈS<br />ILLIMITÉ",
      "app_ios_android": "APP IOS<br />ET ANDROID",
      "app_ios_android_icon": "https://m.10masters.com/images/iphoneicon.original.png",
      "hd_zoom_videos": "VIDÉOS FULL HD ET SUPER ZOOM",
      "guarantee": "GARANTIE DE RETOUR",
      "contact": 'Si vous avez des questions concernant le cours, vous pouvez nous écrire par e-mail et nous vous répondrons immédiatement.',
      "app_text": "Accédez à votre cours en une seconde depuis n'importe quel mobile grâce à notre App.",
      "zoom_text": "Pour pouvoir voir le tatouage en détail, comme si vous l'aviez devant vous. ",
      "try_text": "Vous pouvez essayer 30% du cours. Si ce n'est pas ce que vous cherchez, nous vous rembourserons.",
    }
  };


  let getTrans = (text) => {

    return translations[language][text];

  }


  useEffect(() => {
    const handleResize = () => {
      setForceUpdateFlag((prevFlag) => !prevFlag);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  return (
    <div className="course_features_div">

      <UnderlinedTitle className="text-uppercase" text={getTrans('video_lessons')} />

      <div className="course_features_description" dangerouslySetInnerHTML={{__html: getTrans("course_features_description")}}></div>

      { /* <img className="course_features_platform_image" loading="lazy" alt="10 Masters platform" src="https://m.10masters.com/images/packshot.max-1000x1000.format-webp.webp" /> */}
      <img className="course_features_platform_image" loading="lazy" alt="10 Masters platform" src={packshot_image} />


      {   
        (document.body.clientWidth <= 576) ?
          <Swiper
            centeredSlides={false}
            slidesPerView={2}
            observer={true}
            observeParents={true}
            spaceBetween={'10'}
            rewind={false}
            navigation={false}
            pagination={{
              enabled: true,
              clickable: true
            }}
            modules={[Pagination, Navigation]}
            className="f"
          >

            <SwiperSlide>
              <CoursesFeature
                title={getTrans("guarantee")}
                icon="https://w.10masters.com/media/images/verifiedicon.original.png"
                text={getTrans('try_text')}
              />
            </SwiperSlide>

            <SwiperSlide>
              <CoursesFeature
                title={getTrans("unlimited_access")}
                icon="https://w.10masters.com/media/images/loopicon.original.png"
                text={getTrans('unlimited_access_text')}
              />
            </SwiperSlide>

            <SwiperSlide>
              <CoursesFeature
                title={getTrans("app_ios_android")}
                icon={getTrans("app_ios_android_icon")}
                text={getTrans('app_text')}
              />
            </SwiperSlide>

            <SwiperSlide>
              <CoursesFeature
                title={getTrans("hd_zoom_videos")}
                icon="https://w.10masters.com/media/images/hdicon.original.png"
                text={getTrans('zoom_text')}
              />
            </SwiperSlide>

          </Swiper>
        :

        <div className="course_features_list">
          <CoursesFeature
            title={getTrans("guarantee")}
            icon="https://w.10masters.com/media/images/verifiedicon.original.png"
            text={getTrans('try_text')}
          />
          <CoursesFeature
            title={getTrans("unlimited_access")}
            icon="https://w.10masters.com/media/images/loopicon.original.png"
            text={getTrans('unlimited_access_text')}
          />
          <CoursesFeature
            title={getTrans("app_ios_android")}
            icon={getTrans("app_ios_android_icon")}
            text={getTrans('app_text')}
          />
          <CoursesFeature
            title={getTrans("hd_zoom_videos")}
            icon="https://w.10masters.com/media/images/hdicon.original.png"
            text={getTrans('zoom_text')}
          />
        </div>

      }

      <div className="course_feactures_contact_form_tip invisible" dangerouslySetInnerHTML={{__html: getTrans("contact")}}></div>
    </div>
  );
};
